declare global {
  interface Window { 
    $: any; 
    jQuery: any; 
  }
}
import Vue from 'vue';
import router from './router';
import * as jQuery from 'jquery';
import './plugins/theme';
import './plugins/fontAwesome';

import App from './App.vue';
import store from './store';
import jspdf from 'jspdf';
window.$ = window.jQuery = jQuery;
Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
